import React, { useEffect, useState } from 'react';
import Footer from '../../Components/Footer';
import Header from '../../Components/Header';
import Auth from '../../Function/Auth';
import { ToastContainer } from 'react-toastify';

function Product() {

    const authToken = sessionStorage.getItem('authToken');
    const baseurl = process.env.REACT_APP_BASE_API_URL;
    // =========================
    // STATES
    // =========================
    const [analytics, setAnalytics] = useState({});
    const [products, setProducts] = useState([]);
    const [pagination, setPagination] = useState({});
    const [tableLoading, setTableLoading] = useState(false);
    // FILTER
    const [search, setSearch] = useState("");
    const [status, setStatus] = useState("");
    // =========================
    // EDIT STATES
    // =========================
    const [editProduct, setEditProduct] = useState(null);
    const [editCategory, setEditCategory] = useState("");
    const [editName, setEditName] = useState("");
    const [editDescription, setEditDescription] = useState("");
    const [editMrp, setEditMrp] = useState("");
    const [editPrice, setEditPrice] = useState("");
    const [editWeight, setEditWeight] = useState("");
    const [editStock, setEditStock] = useState("");
    const [editStatus, setEditStatus] = useState("enable");
    const [editImage, setEditImage] = useState(null);
    // =========================
    // CATEGORY STATES
    // =========================
    const [categories, setCategories] = useState([]);
    // IMAGE PREVIEW
    const [previewImage, setPreviewImage] = useState("");
    // =========================
    // ADD PRODUCT STATES
    // =========================
    const [addCategory, setAddCategory] = useState("");
    const [addName, setAddName] = useState("");
    const [addDescription, setAddDescription] = useState("");
    const [addMrp, setAddMrp] = useState("");
    const [addPrice, setAddPrice] = useState("");
    const [addWeight, setAddWeight] = useState("");
    const [addStock, setAddStock] = useState("");
    const [addStatus, setAddStatus] = useState("enable");
    const [addImage, setAddImage] = useState(null);
    const [addPreviewImage, setAddPreviewImage] = useState("");


    // =========================
    // OPEN EDIT MODAL
    // =========================
    const openEditModal = (product) => {

        setEditProduct(product);

        setEditCategory(product.category_id || "");
        setEditName(product.name || "");
        setEditDescription(product.description || "");
        setEditMrp(product.mrp || "");
        setEditPrice(product.price || "");
        setEditWeight(product.weight || "");
        setEditStock(product.stock || "");
        setEditStatus(product.status || "enable");

        // IMAGE PREVIEW
        setPreviewImage(product.image || "");

        // RESET FILE
        setEditImage(null);
    };

    // =========================
    // LOAD DATA
    // =========================
    useEffect(() => {
        fetchProducts(1);
        fetchCategories();
    }, []);

    // =========================
    // FETCH PRODUCTS
    // =========================
    const fetchProducts = async (page = 1) => {

        setTableLoading(false);

        try {

            // QUERY PARAMS
            const queryParams = new URLSearchParams({
                page: page,
                per_page: 10,
                search: search,
                status: status,
            });

            const response = await fetch(
                `${baseurl}/product/list?${queryParams}`,
                {
                    method: "GET",
                    headers: {
                        accept: "*/*",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );

            const data = await response.json();

            console.log("Product Response", data);

            if (data.status) {

                // ANALYTICS
                setAnalytics(data.analytics || {});

                // PRODUCT DATA
                setProducts(data.data.data || []);

                // PAGINATION
                setPagination(data.data || {});
            }

            setTableLoading(true);

        } catch (error) {

            console.log("Fetch Error", error);
            setTableLoading(true);
        }
    };

    // =========================
    // FETCH CATEGORY
    // =========================
    const fetchCategories = async () => {

        try {

            const response = await fetch(
                `${baseurl}/category/list?status=enable&per_page=100`,
                {
                    method: "GET",
                    headers: {
                        accept: "*/*",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );

            const data = await response.json();

            console.log("Category Response", data);

            if (data.status) {

                setCategories(data.data.data || []);
            }

        } catch (error) {

            console.log(error);
        }
    };

    // =========================
    // SEARCH DATA
    // =========================
    const searchData = () => {
        fetchProducts(1);
    };

    // =========================
    // PAGINATION
    // =========================
    const handlePageChange = (page) => {
        fetchProducts(page);
    };

    // =========================
    // IMAGE CHANGE
    // =========================
    const handleImageChange = (e) => {

        const file = e.target.files[0];

        setEditImage(file);

        if (file) {

            setPreviewImage(URL.createObjectURL(file));
        }
    };
    // =========================
    // ADD IMAGE CHANGE
    // =========================
    const handleAddImageChange = (e) => {

        const file = e.target.files[0];

        setAddImage(file);

        if (file) {

            setAddPreviewImage(
                URL.createObjectURL(file)
            );
        }
    };


    // =========================
    // UPDATE PRODUCT
    // =========================
    const updateProduct = async () => {

        try {

            const formData = new FormData();

            formData.append("product_id", editProduct.id);
            formData.append("categories", editCategory);
            formData.append("name", editName);
            formData.append("description", editDescription);
            formData.append("mrp", editMrp);
            formData.append("price", editPrice);
            formData.append("weight", editWeight);
            formData.append("stock", editStock);
            formData.append("status", editStatus);

            if (editImage) {
                formData.append("image", editImage);
            }

            const response = await fetch(
                `${baseurl}/product/update`,
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                    },
                    body: formData,
                }
            );

            const data = await response.json();

            console.log("Update Response", data);

            if (data.status) {

                alert(data.message);

                fetchProducts(pagination.current_page);

                document.getElementById("closeModalBtn").click();

            } else {

                alert(data.message);
            }

        } catch (error) {

            console.log(error);
            alert("Something Went Wrong");
        }
    };

    // =========================
    // ADD PRODUCT
    // =========================
    const addProduct = async () => {

        try {

            const formData = new FormData();

            formData.append("categories", addCategory);
            formData.append("name", addName);
            formData.append("description", addDescription);
            formData.append("mrp", addMrp);
            formData.append("price", addPrice);
            formData.append("weight", addWeight);
            formData.append("stock", addStock);
            formData.append("status", addStatus);

            if (addImage) {
                formData.append("image", addImage);
            }

            const response = await fetch(
                `${baseurl}/product/add`,
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                    },
                    body: formData,
                }
            );

            const data = await response.json();

            console.log("Add Product Response", data);

            if (data.status) {

                alert(data.message);

                // RESET FORM
                setAddCategory("");
                setAddName("");
                setAddDescription("");
                setAddMrp("");
                setAddPrice("");
                setAddWeight("");
                setAddStock("");
                setAddStatus("enable");
                setAddImage(null);
                setAddPreviewImage("");

                // REFRESH LIST
                fetchProducts(1);

                // CLOSE MODAL
                document.getElementById(
                    "closeAddModalBtn"
                ).click();

            } else {

                alert(data.message);
            }

        } catch (error) {

            console.log(error);

            alert("Something Went Wrong");
        }
    };

    return (
        <>
            <Header>

                <Auth />

                <div className="main-content app-content">
                    <div className="container-fluid">

                        {/* PAGE HEADER */}
                        {/* PAGE HEADER */}
                        <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">

                            <div>

                                <h4 className="mb-0 fw-bold">
                                    Product Management
                                </h4>

                                <small className="text-muted">
                                    Manage all products from dashboard
                                </small>

                            </div>

                            {/* ADD PRODUCT BUTTON */}
                            <div className="mt-3 mt-md-0">

                                <button
                                    className="btn btn-primary shadow"
                                    data-bs-toggle="modal"
                                    data-bs-target="#addProductModal"
                                    style={{
                                        borderRadius: "12px",
                                        padding: "10px 20px",
                                        background:
                                            "linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)",
                                        border: "none"
                                    }}
                                >

                                    <i className="fa fa-plus me-2"></i>

                                    Add Product

                                </button>

                            </div>

                        </div>

                        {/* ANALYTICS */}
                        <div className="row">

                            {/* TOTAL PRODUCT */}
                            <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">

                                <div className="card overflow-hidden sales-card bg-primary-gradient">

                                    <div className="px-3 pt-3 pb-2">

                                        <h6 className="mb-3 fs-12 text-fixed-white">
                                            TOTAL PRODUCTS
                                        </h6>

                                        <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                                            {analytics.total_products || 0}
                                        </h4>

                                    </div>

                                </div>

                            </div>

                            {/* ENABLE PRODUCTS */}
                            <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">

                                <div className="card overflow-hidden sales-card bg-success-gradient">

                                    <div className="px-3 pt-3 pb-2">

                                        <h6 className="mb-3 fs-12 text-fixed-white">
                                            ENABLE PRODUCTS
                                        </h6>

                                        <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                                            {analytics.enable_products || 0}
                                        </h4>

                                    </div>

                                </div>

                            </div>

                            {/* DISABLE PRODUCTS */}
                            <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">

                                <div className="card overflow-hidden sales-card bg-danger-gradient">

                                    <div className="px-3 pt-3 pb-2">

                                        <h6 className="mb-3 fs-12 text-fixed-white">
                                            DISABLE PRODUCTS
                                        </h6>

                                        <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                                            {analytics.disable_products || 0}
                                        </h4>

                                    </div>

                                </div>

                            </div>

                            {/* AVERAGE REVIEW */}
                            <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">

                                <div className="card overflow-hidden sales-card bg-warning-gradient">

                                    <div className="px-3 pt-3 pb-2">

                                        <h6 className="mb-3 fs-12 text-fixed-white">
                                            AVERAGE REVIEW
                                        </h6>

                                        <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                                            {analytics.average_review || 0}
                                        </h4>

                                    </div>

                                </div>

                            </div>

                        </div>

                        {/* FILTER */}
                        <div className="row">

                            <div className="col-md-12">

                                <div className="card p-3">

                                    <div className="row">

                                        {/* SEARCH */}
                                        <div className="col-md-4">

                                            <label>
                                                Product Name
                                            </label>

                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter Product Name"
                                                value={search}
                                                onChange={(e) => setSearch(e.target.value)}
                                            />

                                        </div>

                                        {/* STATUS */}
                                        <div className="col-md-4">

                                            <label>
                                                Status
                                            </label>

                                            <select
                                                className="form-control"
                                                value={status}
                                                onChange={(e) => setStatus(e.target.value)}
                                            >
                                                <option value="">
                                                    All
                                                </option>

                                                <option value="enable">
                                                    Enable
                                                </option>

                                                <option value="disable">
                                                    Disable
                                                </option>

                                            </select>

                                        </div>

                                        {/* BUTTON */}
                                        <div className="col-md-4">

                                            <div className="mt-4">

                                                <button
                                                    className="btn btn-primary"
                                                    onClick={searchData}
                                                >
                                                    Search Data
                                                </button>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                        {/* PRODUCT TABLE */}
                        <div className="row">

                            <div className="col-md-12">

                                <div className="card card-table">

                                    <div className="card-header">

                                        <h3 className="card-title text-primary">
                                            Product List
                                        </h3>

                                    </div>

                                    <div className="table-responsive">

                                        {tableLoading ? (

                                            <table className="table table-bordered table-striped text-nowrap">

                                                <thead>

                                                    <tr>

                                                        <th>ID</th>
                                                        <th>Image</th>
                                                        <th>Name</th>
                                                        <th>MRP</th>
                                                        <th>Price</th>
                                                        <th>Weight</th>
                                                        <th>Stock</th>
                                                        <th>Sales</th>
                                                        <th>Review</th>
                                                        <th>Status</th>
                                                        <th>Date</th>
                                                        <th>ACTION</th>

                                                    </tr>

                                                </thead>

                                                <tbody>

                                                    {products.length > 0 ? (

                                                        products.map((item, index) => (

                                                            <tr key={index}>

                                                                <td>
                                                                    {item.id}
                                                                </td>

                                                                <td>

                                                                    <img
                                                                        src={item.image}
                                                                        alt="product"
                                                                        width="50"
                                                                        height="50"
                                                                        style={{
                                                                            borderRadius: "5px",
                                                                            objectFit: "cover"
                                                                        }}
                                                                    />

                                                                </td>

                                                                <td>
                                                                    {item.name || 'N/A'}
                                                                </td>

                                                                <td>
                                                                    ₹ {item.mrp || 0}
                                                                </td>

                                                                <td>
                                                                    ₹ {item.price || 0}
                                                                </td>

                                                                <td>
                                                                    {item.weight || 0}
                                                                </td>

                                                                <td>
                                                                    {item.stock || 0}
                                                                </td>

                                                                <td>
                                                                    {item.sales || 0}
                                                                </td>

                                                                <td>
                                                                    {item.review || 0}
                                                                </td>

                                                                <td>

                                                                    {item.status === 'enable' ? (

                                                                        <span className="badge bg-success">
                                                                            Enable
                                                                        </span>

                                                                    ) : (

                                                                        <span className="badge bg-danger">
                                                                            Disable
                                                                        </span>

                                                                    )}

                                                                </td>

                                                                <td>
                                                                    {item.created_at || 'N/A'}
                                                                </td>
                                                                <td>

                                                                    <button
                                                                        className="btn btn-sm btn-primary"
                                                                        data-bs-toggle="modal"
                                                                        data-bs-target="#editProductModal"
                                                                        onClick={() => openEditModal(item)}
                                                                    >
                                                                        <i className="fa fa-edit"></i>
                                                                    </button>

                                                                </td>

                                                            </tr>

                                                        ))

                                                    ) : (

                                                        <tr>

                                                            <td
                                                                colSpan="11"
                                                                className="text-center"
                                                            >
                                                                No Product Found
                                                            </td>

                                                        </tr>

                                                    )}

                                                </tbody>

                                            </table>

                                        ) : (

                                            <div className="text-center p-5">

                                                <div className="spinner-border" role="status">
                                                    <span className="visually-hidden">
                                                        Loading...
                                                    </span>
                                                </div>

                                            </div>

                                        )}

                                    </div>

                                    {/* PAGINATION */}
                                    <div className="gridjs-footer p-3">

                                        <div className="d-flex justify-content-between align-items-center flex-wrap">

                                            <div>

                                                Showing
                                                <b> {pagination.current_page || 0} </b>
                                                to
                                                <b> {pagination.per_page || 0} </b>
                                                of
                                                <b> {pagination.total || 0} </b>
                                                results

                                            </div>

                                            <div className="mt-2">

                                                {/* PREVIOUS */}
                                                <button
                                                    className="btn btn-sm btn-primary me-2"
                                                    disabled={pagination.current_page === 1}
                                                    onClick={() =>
                                                        handlePageChange(
                                                            pagination.current_page - 1
                                                        )
                                                    }
                                                >
                                                    Previous
                                                </button>

                                                {/* NEXT */}
                                                <button
                                                    className="btn btn-sm btn-primary"
                                                    disabled={
                                                        pagination.current_page === pagination.last_page
                                                    }
                                                    onClick={() =>
                                                        handlePageChange(
                                                            pagination.current_page + 1
                                                        )
                                                    }
                                                >
                                                    Next
                                                </button>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>
                </div>

                <ToastContainer />

                {/* =========================
EDIT PRODUCT MODAL
========================= */}

                <div
                    className="modal fade"
                    id="editProductModal"
                    tabIndex="-1"
                    aria-hidden="true"
                >

                    <div className="modal-dialog modal-xl modal-dialog-centered">

                        <div
                            className="modal-content border-0 shadow-lg"
                            style={{
                                borderRadius: "20px",
                                overflow: "hidden"
                            }}
                        >

                            {/* HEADER */}
                            <div
                                className="modal-header border-0 text-white"
                                style={{
                                    background:
                                        "linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)"
                                }}
                            >

                                <div>

                                    <h4 className="modal-title fw-bold mb-1">
                                        Update Product
                                    </h4>

                                    <small className="opacity-75">
                                        Edit product details and save changes
                                    </small>

                                </div>

                                <button
                                    type="button"
                                    className="btn-close btn-close-white"
                                    data-bs-dismiss="modal"
                                    id="closeModalBtn"
                                ></button>

                            </div>

                            {/* BODY */}
                            <div className="modal-body p-4">

                                <div className="row">

                                    {/* LEFT SIDE */}
                                    <div className="col-lg-4">

                                        <div
                                            className="card border-0 shadow-sm"
                                            style={{
                                                borderRadius: "16px"
                                            }}
                                        >

                                            <div className="card-body text-center">

                                                <div className="mb-3">

                                                    <img
                                                        src={
                                                            previewImage ||
                                                            "https://via.placeholder.com/300x300?text=No+Image"
                                                        }
                                                        alt="Preview"
                                                        className="img-fluid"
                                                        style={{
                                                            width: "100%",
                                                            height: "300px",
                                                            objectFit: "cover",
                                                            borderRadius: "16px",
                                                            border:
                                                                "3px solid #f1f5f9"
                                                        }}
                                                    />

                                                </div>

                                                <label
                                                    className="btn btn-primary w-100"
                                                    style={{
                                                        borderRadius: "10px"
                                                    }}
                                                >

                                                    <i className="fa fa-upload me-2"></i>
                                                    Upload Product Image

                                                    <input
                                                        type="file"
                                                        hidden
                                                        onChange={handleImageChange}
                                                    />

                                                </label>

                                            </div>

                                        </div>

                                    </div>

                                    {/* RIGHT SIDE */}
                                    <div className="col-lg-8">

                                        <div
                                            className="card border-0 shadow-sm"
                                            style={{
                                                borderRadius: "16px"
                                            }}
                                        >

                                            <div className="card-body">

                                                <div className="row">

                                                    {/* CATEGORY */}
                                                    <div className="col-md-6 mb-4">

                                                        <label className="form-label fw-semibold">
                                                            Category
                                                        </label>

                                                        <select
                                                            className="form-control"
                                                            value={editCategory}
                                                            onChange={(e) =>
                                                                setEditCategory(
                                                                    e.target.value
                                                                )
                                                            }
                                                            style={{
                                                                height: "50px",
                                                                borderRadius: "10px"
                                                            }}
                                                        >

                                                            <option value="">
                                                                Select Category
                                                            </option>

                                                            {categories.map((category) => (

                                                                <option
                                                                    key={category.id}
                                                                    value={category.id}
                                                                >
                                                                    {category.name}
                                                                </option>

                                                            ))}

                                                        </select>

                                                    </div>

                                                    {/* PRODUCT NAME */}
                                                    <div className="col-md-6 mb-4">

                                                        <label className="form-label fw-semibold">
                                                            Product Name
                                                        </label>

                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={editName}
                                                            onChange={(e) =>
                                                                setEditName(
                                                                    e.target.value
                                                                )
                                                            }
                                                            style={{
                                                                height: "50px",
                                                                borderRadius: "10px"
                                                            }}
                                                        />

                                                    </div>

                                                    {/* DESCRIPTION */}
                                                    <div className="col-md-12 mb-4">

                                                        <label className="form-label fw-semibold">
                                                            Description
                                                        </label>

                                                        <textarea
                                                            className="form-control"
                                                            rows="4"
                                                            value={editDescription}
                                                            onChange={(e) =>
                                                                setEditDescription(
                                                                    e.target.value
                                                                )
                                                            }
                                                            style={{
                                                                borderRadius: "10px"
                                                            }}
                                                        ></textarea>

                                                    </div>

                                                    {/* MRP */}
                                                    <div className="col-md-4 mb-4">

                                                        <label className="form-label fw-semibold">
                                                            MRP
                                                        </label>

                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            value={editMrp}
                                                            onChange={(e) =>
                                                                setEditMrp(
                                                                    e.target.value
                                                                )
                                                            }
                                                            style={{
                                                                height: "50px",
                                                                borderRadius: "10px"
                                                            }}
                                                        />

                                                    </div>

                                                    {/* PRICE */}
                                                    <div className="col-md-4 mb-4">

                                                        <label className="form-label fw-semibold">
                                                            Price
                                                        </label>

                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            value={editPrice}
                                                            onChange={(e) =>
                                                                setEditPrice(
                                                                    e.target.value
                                                                )
                                                            }
                                                            style={{
                                                                height: "50px",
                                                                borderRadius: "10px"
                                                            }}
                                                        />

                                                    </div>

                                                    {/* STOCK */}
                                                    <div className="col-md-4 mb-4">

                                                        <label className="form-label fw-semibold">
                                                            Stock
                                                        </label>

                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            value={editStock}
                                                            onChange={(e) =>
                                                                setEditStock(
                                                                    e.target.value
                                                                )
                                                            }
                                                            style={{
                                                                height: "50px",
                                                                borderRadius: "10px"
                                                            }}
                                                        />

                                                    </div>

                                                    {/* WEIGHT */}
                                                    <div className="col-md-6 mb-4">

                                                        <label className="form-label fw-semibold">
                                                            Weight
                                                        </label>

                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            value={editWeight}
                                                            onChange={(e) =>
                                                                setEditWeight(
                                                                    e.target.value
                                                                )
                                                            }
                                                            style={{
                                                                height: "50px",
                                                                borderRadius: "10px"
                                                            }}
                                                        />

                                                    </div>

                                                    {/* STATUS */}
                                                    <div className="col-md-6 mb-4">

                                                        <label className="form-label fw-semibold">
                                                            Status
                                                        </label>

                                                        <select
                                                            className="form-control"
                                                            value={editStatus}
                                                            onChange={(e) =>
                                                                setEditStatus(
                                                                    e.target.value
                                                                )
                                                            }
                                                            style={{
                                                                height: "50px",
                                                                borderRadius: "10px"
                                                            }}
                                                        >

                                                            <option value="enable">
                                                                Enable
                                                            </option>

                                                            <option value="disable">
                                                                Disable
                                                            </option>

                                                        </select>

                                                    </div>

                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>

                            {/* FOOTER */}
                            <div className="modal-footer border-0 px-4 pb-4">

                                <button
                                    type="button"
                                    className="btn btn-light px-4"
                                    data-bs-dismiss="modal"
                                    style={{
                                        borderRadius: "10px",
                                        height: "45px"
                                    }}
                                >
                                    Close
                                </button>

                                <button
                                    type="button"
                                    className="btn btn-primary px-4"
                                    onClick={updateProduct}
                                    style={{
                                        borderRadius: "10px",
                                        height: "45px",
                                        background:
                                            "linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)",
                                        border: "none"
                                    }}
                                >

                                    <i className="fa fa-save me-2"></i>

                                    Update Product

                                </button>

                            </div>

                        </div>

                    </div>

                </div>

                {/* =========================
ADD PRODUCT MODAL
========================= */}

                <div
                    className="modal fade"
                    id="addProductModal"
                    tabIndex="-1"
                    aria-hidden="true"
                >

                    <div className="modal-dialog modal-xl modal-dialog-centered">

                        <div
                            className="modal-content border-0 shadow-lg"
                            style={{
                                borderRadius: "20px",
                                overflow: "hidden"
                            }}
                        >

                            {/* HEADER */}
                            <div
                                className="modal-header border-0 text-white"
                                style={{
                                    background:
                                        "linear-gradient(135deg, #0ea5e9 0%, #2563eb 100%)"
                                }}
                            >

                                <div>

                                    <h4 className="modal-title fw-bold mb-1">
                                        Add New Product
                                    </h4>

                                    <small className="opacity-75">
                                        Create a new product for your store
                                    </small>

                                </div>

                                <button
                                    type="button"
                                    className="btn-close btn-close-white"
                                    data-bs-dismiss="modal"
                                    id="closeAddModalBtn"
                                ></button>

                            </div>

                            {/* BODY */}
                            <div className="modal-body p-4">

                                <div className="row">

                                    {/* LEFT */}
                                    <div className="col-lg-4">

                                        <div
                                            className="card border-0 shadow-sm"
                                            style={{
                                                borderRadius: "16px"
                                            }}
                                        >

                                            <div className="card-body text-center">

                                                <img
                                                    src={
                                                        addPreviewImage ||
                                                        "https://via.placeholder.com/300x300?text=Upload+Image"
                                                    }
                                                    alt="Preview"
                                                    className="img-fluid mb-3"
                                                    style={{
                                                        width: "100%",
                                                        height: "300px",
                                                        objectFit: "cover",
                                                        borderRadius: "16px",
                                                        border:
                                                            "3px solid #f1f5f9"
                                                    }}
                                                />

                                                <label
                                                    className="btn btn-primary w-100"
                                                    style={{
                                                        borderRadius: "10px"
                                                    }}
                                                >

                                                    <i className="fa fa-upload me-2"></i>

                                                    Upload Product Image

                                                    <input
                                                        type="file"
                                                        hidden
                                                        onChange={
                                                            handleAddImageChange
                                                        }
                                                    />

                                                </label>

                                            </div>

                                        </div>

                                    </div>

                                    {/* RIGHT */}
                                    <div className="col-lg-8">

                                        <div
                                            className="card border-0 shadow-sm"
                                            style={{
                                                borderRadius: "16px"
                                            }}
                                        >

                                            <div className="card-body">

                                                <div className="row">

                                                    {/* CATEGORY */}
                                                    <div className="col-md-6 mb-4">

                                                        <label className="form-label fw-semibold">
                                                            Category
                                                        </label>

                                                        <select
                                                            className="form-control"
                                                            value={addCategory}
                                                            onChange={(e) =>
                                                                setAddCategory(
                                                                    e.target.value
                                                                )
                                                            }
                                                            style={{
                                                                height: "50px",
                                                                borderRadius: "10px"
                                                            }}
                                                        >

                                                            <option value="">
                                                                Select Category
                                                            </option>

                                                            {categories.map(
                                                                (category) => (

                                                                    <option
                                                                        key={category.id}
                                                                        value={
                                                                            category.id
                                                                        }
                                                                    >
                                                                        {
                                                                            category.name
                                                                        }
                                                                    </option>

                                                                )
                                                            )}

                                                        </select>

                                                    </div>

                                                    {/* NAME */}
                                                    <div className="col-md-6 mb-4">

                                                        <label className="form-label fw-semibold">
                                                            Product Name
                                                        </label>

                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={addName}
                                                            onChange={(e) =>
                                                                setAddName(
                                                                    e.target.value
                                                                )
                                                            }
                                                            style={{
                                                                height: "50px",
                                                                borderRadius: "10px"
                                                            }}
                                                        />

                                                    </div>

                                                    {/* DESCRIPTION */}
                                                    <div className="col-md-12 mb-4">

                                                        <label className="form-label fw-semibold">
                                                            Description
                                                        </label>

                                                        <textarea
                                                            className="form-control"
                                                            rows="4"
                                                            value={addDescription}
                                                            onChange={(e) =>
                                                                setAddDescription(
                                                                    e.target.value
                                                                )
                                                            }
                                                            style={{
                                                                borderRadius: "10px"
                                                            }}
                                                        ></textarea>

                                                    </div>

                                                    {/* MRP */}
                                                    <div className="col-md-4 mb-4">

                                                        <label className="form-label fw-semibold">
                                                            MRP
                                                        </label>

                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            value={addMrp}
                                                            onChange={(e) =>
                                                                setAddMrp(
                                                                    e.target.value
                                                                )
                                                            }
                                                            style={{
                                                                height: "50px",
                                                                borderRadius: "10px"
                                                            }}
                                                        />

                                                    </div>

                                                    {/* PRICE */}
                                                    <div className="col-md-4 mb-4">

                                                        <label className="form-label fw-semibold">
                                                            Price
                                                        </label>

                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            value={addPrice}
                                                            onChange={(e) =>
                                                                setAddPrice(
                                                                    e.target.value
                                                                )
                                                            }
                                                            style={{
                                                                height: "50px",
                                                                borderRadius: "10px"
                                                            }}
                                                        />

                                                    </div>

                                                    {/* STOCK */}
                                                    <div className="col-md-4 mb-4">

                                                        <label className="form-label fw-semibold">
                                                            Stock
                                                        </label>

                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            value={addStock}
                                                            onChange={(e) =>
                                                                setAddStock(
                                                                    e.target.value
                                                                )
                                                            }
                                                            style={{
                                                                height: "50px",
                                                                borderRadius: "10px"
                                                            }}
                                                        />

                                                    </div>

                                                    {/* WEIGHT */}
                                                    <div className="col-md-6 mb-4">

                                                        <label className="form-label fw-semibold">
                                                            Weight
                                                        </label>

                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            value={addWeight}
                                                            onChange={(e) =>
                                                                setAddWeight(
                                                                    e.target.value
                                                                )
                                                            }
                                                            style={{
                                                                height: "50px",
                                                                borderRadius: "10px"
                                                            }}
                                                        />

                                                    </div>

                                                    {/* STATUS */}
                                                    <div className="col-md-6 mb-4">

                                                        <label className="form-label fw-semibold">
                                                            Status
                                                        </label>

                                                        <select
                                                            className="form-control"
                                                            value={addStatus}
                                                            onChange={(e) =>
                                                                setAddStatus(
                                                                    e.target.value
                                                                )
                                                            }
                                                            style={{
                                                                height: "50px",
                                                                borderRadius: "10px"
                                                            }}
                                                        >

                                                            <option value="enable">
                                                                Enable
                                                            </option>

                                                            <option value="disable">
                                                                Disable
                                                            </option>

                                                        </select>

                                                    </div>

                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>

                            {/* FOOTER */}
                            <div className="modal-footer border-0 px-4 pb-4">

                                <button
                                    type="button"
                                    className="btn btn-light px-4"
                                    data-bs-dismiss="modal"
                                    style={{
                                        borderRadius: "10px",
                                        height: "45px"
                                    }}
                                >
                                    Close
                                </button>

                                <button
                                    type="button"
                                    className="btn btn-primary px-4"
                                    onClick={addProduct}
                                    style={{
                                        borderRadius: "10px",
                                        height: "45px",
                                        background:
                                            "linear-gradient(135deg, #0ea5e9 0%, #2563eb 100%)",
                                        border: "none"
                                    }}
                                >

                                    <i className="fa fa-save me-2"></i>

                                    Add Product

                                </button>

                            </div>

                        </div>

                    </div>

                </div>

            </Header>

            <Footer />
        </>
    );
}

export default Product;